import React, { useState, useRef } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import Chat from '../components/chat/Chat';
import PomodoroTimer from '../components/studies/PomodoroTimer';
import '../styles/Study.css';
import { useEffect } from 'react';
import { useTimer } from '../context/TimerContext';


const Study = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [showChat, setShowChat] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const toast = useRef(null);
    const audioRef = useRef(null);
    const [isStudyPage, setIsStudyPage] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768 && isFullScreen) {
                setIsFullScreen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        // Run once on mount in case already small
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, [isFullScreen, setIsFullScreen]);

    const toggleChat = () => {
        if (!isFullScreen) {
            setShowChat(prev => !prev);
        }
    };

    const toggleFullScreen = () => {
        setIsFullScreen(prev => !prev);
        setShowChat(false); // Hide overlay chat when entering full screen
    };

    useEffect(() => {
        setIsStudyPage(true);
        return () => setIsStudyPage(false);
    }, [setIsStudyPage]);

    return (
        <div className={`study-method-container ${isFullScreen ? 'full-screen-mode' : ''}`}>
            <Toast ref={toast} />

            {!isFullScreen ? (
                <>
                    <div className="content-section">
                        <h1 className="page-title">StudyHub</h1>
                                <PomodoroTimer
                                    toast={toast}
                                    audioRef={audioRef}
                                    toggleFullScreen={toggleFullScreen}
                                    isFullScreen={true}
                                    setIsStudyPage={setIsStudyPage} // Add this prop here too
                                />

                    </div>

                    <Button
                        icon="pi pi-comments"
                        className="p-button-rounded chat-toggle-btn"
                        onClick={toggleChat}
                    />

                    {showChat && (
                        <div className="chat-overlay">
                            <div className="chat-header">
                                <h3>Chat</h3>
                                <Button
                                    icon="pi pi-times"
                                    className="p-button-rounded p-button-text"
                                    onClick={toggleChat}
                                />
                            </div>
                            <div className="chat-wrapper">
                                <Chat isEmbedded={true} />
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <div className="split-screen-container">
                    <div className="split-screen-left">
                        <div className="split-header">
                            <h2 className='pomodoro-timer'>Pomodoro Timer</h2>
                            <Button
                                icon="pi pi-window-minimize"
                                className="p-button-rounded p-button-outlined"
                                onClick={toggleFullScreen}
                                tooltip="Exit Full Screen View"
                            />
                        </div>
                        <div className="split-content">
                            <PomodoroTimer
                                toast={toast}
                                audioRef={audioRef}
                                toggleFullScreen={toggleFullScreen}
                                isFullScreen={true}
                            />
                        </div>
                    </div>

                    <div className="split-screen-right">
                        <div className="split-header">
                            <h2>Chat</h2>
                        </div>
                        <div className="split-content">
                            <Chat isEmbedded={true} />
                        </div>
                    </div>
                </div>
            )}

            <audio ref={audioRef} />
        </div>
    );
};

export default Study;